import {insert} from "object-path-immutable";
import {toPng} from "html-to-image";
import request from "../../../../../../Services/API/Requests";
import listRequestWrapper from "../../../../../../Services/API/listRequestWrapper";
import getSafe from "../../../../../JsonScreen/Utils/getSafeValues";
import asyncForEach from "../../../../../../Utils/Form/FormDynamic/Utils/asyncForEach";
import {successMessage} from "../../../../../JsonScreen/Utils";
import {findAdditionalListNames, findAllListNames, findForFeed} from "./findAllLists";
import {saveImages} from "./saveImages";
import findByString from "../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {omit} from "lodash";
import {screenValuesTemplate} from "../screenDesigner.hook";
import {generateScriptSuggestions} from "./generateScriptSuggestions";

//screen designer actions
const getScreenValues = async (id, type = 'screen') => {
    try {
        let screenValues = id ? await request({
            url: 'screen/read',
            method: 'POST',
            data: {id: id}
        }) : screenValuesTemplate;

        if (!screenValues.children) {
            screenValues.children = []
        }

        //add components uids  for old screen versions

        const withIds = addComponentsUniqIds(screenValues);
        screenValues.children = removeUnusedProperties({children: withIds});


        let screenTypeProps = await request({
            url: 'screenType/read',
            data: {
                id: !id ? type : screenValues.type === 'container' ? 'screen' : screenValues.type ? screenValues.type : type
            }
        })
        screenValues.type = screenTypeProps.id;

        const listStorage = await findAllListNames(screenValues);
        const additionalLists = findAdditionalListNames(screenValues);
        const feedStorage = await findForFeed(screenValues);
        const scriptSuggestions = await generateScriptSuggestions(screenValues)

        return {
            listStorage: [...listStorage, ...feedStorage, ...additionalLists],
            screenValues,
            screenTypeProps,
            scriptSuggestions
        }
    } catch (e) {
        console.log(e);
        return {listStorage: [], screenValues: {children: []}, screenTypeProps: {}}
    }
};
const getAvailableLists = async () => {
    try {
        return await listRequestWrapper('list');
    } catch (e) {
        console.log(e)
    }
};
const savePreparedLists = async (preparedLists = {}) => {
    const lists = Object.keys(preparedLists);
    let updatedLists = {...preparedLists}
    if (lists.length) {
        await asyncForEach(lists, async (list) => {
            try {
                if (preparedLists[list].touched) {
                    const updatedList = await request({
                        url: 'list/update',
                        data: preparedLists[list].schema
                    })
                    updatedLists[updatedList.id] = {schema: updatedList, touched: false}
                }
            } catch (e) {
                console.log('list update error', e)
            }
        })
        return updatedLists;
    }

    return updatedLists
};
const saveScreenDesigner = async (props) => {
    const {
        designerType,
        setLoading,
        screenValues,
        preparedToSaveImages,
        preparedToSaveLists,
        history,
        location,
        enqueueSnackbar,
        isPreSave,
        SCREEN_DESIGNER_VERSION,
        inParamId
    } = props;
    const locationState = location.state ? location.state : {};
    try {
        setLoading(true);
        let svg;
        let newScreenValues = await saveImages(preparedToSaveImages, screenValues);
        const updatedLists = await savePreparedLists(preparedToSaveLists);
        console.log(inParamId)
        if (designerType === 'template') {
            const screen_doc = document.getElementById("screen_designer_root");
            svg = await toPng(screen_doc)
        }
        const response = await request({
            url: `screen/update`,
            method: 'POST',
            data: {
                ...newScreenValues,
                version: inParamId ? newScreenValues.version : SCREEN_DESIGNER_VERSION,
                thumbnail: svg,
            }
        });
        setLoading(false);

        if (!response.children) {
            response.children = [];
        }

        enqueueSnackbar(
            successMessage(response.id, history, location.pathname, locationState.prevState),
            {variant: `success`}
        );
        if (locationState.prevPath && !isPreSave) {
            history.push({
                pathname: locationState.prevPath,
                state: {prevListState: locationState.prevListState}
            });
            return
        }
        !isPreSave && history.goBack()
        return {
            updatedScreen: response,
            updatedLists
        };
    } catch (e) {
        let message = getSafe(() => e.data.status.message[0].text, 'Error');
        enqueueSnackbar(message, {variant: 'error'});
        setLoading(false);
        console.log(e)
    }

};
const removeScreenDesigner = async (props) => {
    const {id, history, location: {state = {}}, enqueueSnackbar, designerType, setLoading} = props;
    try {
        setLoading(true);
        await request({
            url: `${designerType}/delete`,
            method: 'POST',
            data: {id: id}
        });
        enqueueSnackbar('Success', {variant: 'success'});
        setLoading(false);
        if (state.prevPath) {
            history.push({
                pathname: state.prevPath,
                state: {prevListState: state.prevListState}
            });
            return
        }
        history.goBack();
    } catch (e) {
        setLoading(false);
        let message = getSafe(() => e.data.status.message[0].text, 'Error');
        enqueueSnackbar(message, {variant: 'error'});
        console.log(e)
    }
};
const closeScreenDesigner = (props) => {
    const {location: {state = {}}, history, isChanged} = props;
    if (isChanged) {
        //TODO open confirmation
    } else {
        if (state.prevPath) {
            history.push({
                pathname: state.prevPath,
                state: {prevListState: state.prevListState}
            });
        } else {
            history.goBack();
        }
    }
};
const getResponsiveStyles = (styles = [], resolution) => {
    if (styles[0]) {
        const currentStylesObj = styles[0]
        if (resolution !== 'desktop') {
            return currentStylesObj[resolution] ? currentStylesObj[resolution] : currentStylesObj
        }
        return currentStylesObj
    }

    return {};
}

function fixBrokenParams(string) {
    function replacer(match) {
        return match.replace(/<[^>]*>?/gm, '')
    }

    return string.replaceAll(new RegExp(/{(.*?)}/, 'gm'), replacer)
}

//screen v.2
function addComponentsUniqIds(screenValues) {
    return screenValues.children.map(({children, ...rest}) => {
        const v = {...rest}
        if (v.type && !v.id) {
            v.id = generateUid(v)
        }
        if (children) v.children = addComponentsUniqIds({...v, children})

        return v
    })
}

function regenerateIds(screenValues) {
    return screenValues.children.map(({children, ...rest}) => {
        const v = {...rest}
        v.id = generateUid(v)
        if (children) v.children = regenerateIds({...v, children})
        return v
    })
}

function generateUid(component) {
    return component.type + "_" + (+new Date * Math.random()).toString(36).substring(0, 6)
}

function removeUnusedProperties(screenValues) {
    return screenValues.children.map(({children, ...rest}) => {
        const v = {...rest}
        if (v.type === 'field' && v.properties.type === 'entityExternal') {
            v.properties.schema = omit(v.properties.schema, ['collection', 'auditable', 'endPoints', 'uniqueCollection']);
        }
        if (children) v.children = removeUnusedProperties({...v, children})
        return v
    })
}

//DND
const onDrop = (screenValues, setLists, item, direction, path) => {
    if (item.type === 'list') {
        setLists({})
    }

    return insert(screenValues, path, item, direction)
};


//screen bar utils
async function getBackgroundImage(id) {
    try {
        const image = await request({
            url: 'files/getFiles',
            data: {id}
        })
        return `url(${image.content})`
    } catch (e) {
        return ''
    }
}

function getBackgroundImageFromStore(path, uploadedImages, property) {
    let findImage = findByString(uploadedImages, `${path}.styles.0.${property}`);
    return findImage ? `url(${findImage.content})` : ''
}

export {
    getScreenValues,
    getAvailableLists,
    saveScreenDesigner,
    removeScreenDesigner,
    closeScreenDesigner,
    onDrop,
    getBackgroundImageFromStore,
    getBackgroundImage,
    getResponsiveStyles,
    fixBrokenParams,
    addComponentsUniqIds,
    generateUid,
    regenerateIds
}